import { Component, NgZone, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';
import { AuthService } from 'src/app/services/gigya/auth.service';
import { GigyaService } from 'src/app/services/gigya/gigya.service';
import { MenuService } from 'src/app/services/menu.service';
import { MinorService, PayloadExport } from 'src/app/services/minor/minor.service';
import { CustomNgxSpinnerService } from 'src/app/services/spinner/custom-ngx-spinner.service';
import { AppToastService } from 'src/app/services/toast/app-toast.service';
import { TranslationsService } from 'src/app/services/translations/translations.service';
import { TutorService } from 'src/app/services/tutor/tutor.service';
import { paramsShowScreenSet, responseisAvailableLoginID, responseGetAccountInfo } from 'src/app/types/gigya-type';
import { ModalComponent } from 'src/app/utility/modal/modal.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [
    NgbActiveModal,
  ]
})
export class HomeComponent {
  userLogged: boolean = false;
  screenLoaded: boolean = false;
  isMinorsProfile: boolean = true;
  isTutorProfile: boolean = false;
  minorUID: string | null = "";
  minorInfo: responseGetAccountInfo = {};
  tutorInfo: responseGetAccountInfo = {};
  lang: string | null = "";
  pwrt: string = "";
  private modalService = inject(NgbModal);
  //listMinors: any = [];
  listMinors = new BehaviorSubject([]);
  listMinors$ = this.listMinors.asObservable();

  constructor(
    private activeRoute: ActivatedRoute,
    public tutorService: TutorService,
    public toastService: AppToastService,
    private gigya: GigyaService,
    private ngZone: NgZone,
    public auth: AuthService,
    private menu: MenuService,
    private trans: TranslationsService,
    private minorService: MinorService,
    public loading: CustomNgxSpinnerService,
    public transPipe: TranslationPipe
  ) {
    
    this.trans.lang.subscribe((lg: any) => {
      this.lang = lg;
    });
    this.trans.getLang(this.activeRoute.paramMap);
    this.activeRoute.queryParams.subscribe(params => {
      this.minorUID = params['UID'];
      this.pwrt = params["pwrt"];
    });
    this.gigya.onGigyaServiceReady();
  }

  callbackIsAvailableLoginID(response: responseisAvailableLoginID) {
    this.ngZone.run(() => {
      let params: paramsShowScreenSet = {
        screenSet: "Parent-RegistrationLogin",
        startScreen: response?.isAvailable ? "gigya-register-screen" : "gigya-login-screen",
        containerID: "registrationLoginContainer",
        context: {
          userMinor: this.minorInfo
        },
        lang: this.lang || location?.pathname?.split("/")[1]
      }
      this.gigya.showScreenSet(params);
    });

  }
  getFavouriteTeams(allInitiatives: string[]) {
    allInitiatives.forEach((init: string) => {
      this.minorService.getFavoriteTeam(init);
    });
  }

  getInitiatives(resp: any) {
    let allInitiatives: any = [];
    for (let us of resp) {
      for (let cn of us.data.pending_consents) {
        if (!allInitiatives.find((el: any) => el === cn.initiativeId)) {
          allInitiatives.push(cn.initiativeId);
        }
      }
    }
    this.getFavouriteTeams(allInitiatives);
  }
  getMinors(user: any) {
    if (user.logged) {
      this.auth.getListMinors(this.tutorInfo).subscribe((resp: any) => {
        if(resp?.length >0){
          this.listMinors.next(resp);
          this.getInitiatives(resp);
        }else{
          this.gigya.logout();
        }


      });
    } else {
      this.loading.loadingOff();
    }
  }
  getChildrenUids() {
    let chUids: any = "";
    if (!this.tutorInfo?.data?.childrenUIDs) {
      chUids = this.minorInfo.UID;
    } else if (!this.tutorInfo?.data?.childrenUIDs?.split(",").includes(this.minorInfo.UID || "") && this.minorInfo.UID) {
      chUids = [...this.tutorInfo.data.childrenUIDs.split(","), ...[this.minorInfo.UID]].join(",")
    }
    return chUids;
  }
  userIsLogged(lg: any) {
    let data: any = {}
    this.tutorInfo = lg?.userLogged;
    data.childrenUIDs = this.getChildrenUids();
    if(!this.tutorInfo.isVerified){
      this.tutorService.verifyEmailTutor(this.tutorInfo.UID).subscribe((respVer)=>{console.log("Tutor Verified!")});
    }
    if (data.childrenUIDs) {
      this.ngZone.run(() => {
        this.gigya.setAccountInfo({
          data: data,
          callback: (resp: any) => {
            if (resp.errorCode === 0) {
              this.getMinors(lg);
            } else {
              this.loading.loadingOff();
              this.gigya.logout();
            }
          }
        }
        );
      });

    } else {
      this.getMinors(lg);
    }
  }
  registrationLogin(lg: any) {
    if (lg.logged && this.minorUID) {
      this.tutorService.getMinor(this.minorUID).subscribe((minInf: responseGetAccountInfo) => {
        this.minorInfo = minInf;
        this.userIsLogged(lg);
      });
    } else if (this.minorUID && lg.userLogged) {
      this.tutorService.getMinor(this.minorUID).subscribe((minInf: responseGetAccountInfo) => {
        this.minorInfo = minInf;
        if (this.minorInfo?.data?.tutorEmail) {
          this.gigya.isAvailableLoginID({
            loginID: this.minorInfo?.data?.tutorEmail,
            callback: this.callbackIsAvailableLoginID.bind(this)
          }
          )
        }
      });
    }else if(lg.logged && !this.pwrt && !this.minorUID){
      this.userIsLogged(lg);
    } else if (!this.pwrt && !this.minorUID) {
      this.gigya.showScreenSet({
        screenSet: "Parent-RegistrationLogin",
        startScreen: "gigya-login-screen",
        containerID: "registrationLoginContainer",
        context: {
          userMinor: this.minorInfo
        },
        lang: this.lang || location?.pathname?.split("/")[1]
      });
    } else if (this.pwrt){
      this.screenLoaded = true;
      this.gigya.showScreenSet({
        screenSet: "Parent-RegistrationLogin",
        startScreen: "gigya-reset-password-screen",
        containerID: "registrationLoginContainer",
        context: {
          userMinor: this.minorInfo
        },
        lang: this.lang || location?.pathname?.split("/")[1]
      });
    }
  }
  ngAfterViewInit() {
    this.gigya.isGigyaLoaded$.subscribe((loaded) => {
      if (loaded) {
        this.auth.loggedIn$.subscribe((lg: any) => {
          this.auth.screenLoad.next({ nameScreen: "screen-loaded" });
          this.registrationLogin(lg);
        });
        this.auth.checkSessionLogin();
        this.auth.addListener();
        this.menu.showMinorMenu.subscribe(minor => {
          this.isMinorsProfile = minor;
        });
        this.menu.showTutorMenu.subscribe(tutor => {
          this.isTutorProfile = tutor;
        });
      }
    });
  }


  deleteMinor(minOrplus: any) {
    const modalRef = this.modalService.open(ModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'deleteModal'
    });
    modalRef.componentInstance.bodyMsg1 = `${minOrplus.isMinor ? this.transPipe.transform("label.msgDeleteUser") : this.transPipe.transform("label.msgDisableUser")}`;
    modalRef.componentInstance.bodyMsg2 = `${minOrplus.isMinor ?  this.transPipe.transform("label.confirmDeleteUser") :  this.transPipe.transform("label.confirmeDisableUser")}`;
    modalRef.componentInstance.title = `${minOrplus.isMinor ? this.transPipe.transform("label.userDeleted") : this.transPipe.transform("label.modalDisableTitle")}`;
    modalRef.componentInstance.submitButton = minOrplus.isMinor ? this.transPipe.transform("button.deleteUser") : this.transPipe.transform("button.disableUser");
    
    modalRef.closed.subscribe((closed) => {
      console.log(closed);
      if (minOrplus.isMinor) {
        this.minorService.deleteMinor(minOrplus.uid, minOrplus.signatureTimestamp, minOrplus.UIDSignature, minOrplus.tutorUID).subscribe(((resp: any) => {
          console.log(resp);
          if (resp?.errorCode === 0) {
            this.toastService.showSuccess("label.successMessageDeleted");
            this.minorService.toBeDeleted.next({ uid: minOrplus.uid, deleted: true, disabled: false });
            let exportData ={
              childuid: minOrplus.uid,
              uid: this.tutorInfo.UID,
              lang: this.lang
            } as PayloadExport;
            this.minorService.exportData(exportData).subscribe(()=>{
              this.toastService.showSuccess("export.completed");
            });
          }
        }));
      } else {
        this.minorService.disableMinorPlus(minOrplus.uid).subscribe(((resp: any) => {
          console.log(resp);
          if (resp?.errorCode === 0) {
            this.toastService.showSuccess("label.successMessageDisable");
            this.minorService.toBeDeleted.next({ uid: minOrplus.uid, deleted: false, disabled: true });
            this.tutorService.changeStatus.next({ active: false, pending: true, email: { value: minOrplus.email } });

          }
        }));
      }

    });
    modalRef.dismissed.subscribe((dismissed) => {
      console.log(dismissed)
    })
  }

}